module.exports = __webpack_public_path__ + "img/service-kaufuberprufung.96052630.jpg";